import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.reduce";
import React, { Children } from 'react';

var createSeparator = function createSeparator(separator, idx) {
  if (typeof separator === 'string') {
    return separator;
  }

  return React.cloneElement(separator, {
    key: "separator-".concat(idx)
  });
};

var Join = function Join(_ref) {
  var children = _ref.children,
      separator = _ref.separator;
  var items = Children.toArray(children);

  if (!items.length) {
    return items;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, items.filter(function (el) {
    return el || el === 0;
  }).reduce(function (acc, curr, i) {
    if (!i) {
      return acc.concat([curr]);
    }

    return acc.concat([createSeparator(separator, i), curr]);
  }, []));
};

export default Join;